import PropTypes from 'prop-types'
import React from 'react'

import { POSTBATTLE_TABS_CAPTIONS } from './constants.jsx'

import classNames from 'classnames'
import styles from './Tabs.scss'

export class Tabs extends React.Component {

    static propTypes = {
        tabs: PropTypes.array.isRequired,
        selected: PropTypes.string.isRequired,
        handleClick: PropTypes.func.isRequired,
    }

    render() {
        const tabs = this.props.tabs.map((tab, index) => {
            const selected = this.props.selected === tab
            const className = classNames(styles.item, {
                [styles.item__selected] : selected,
            })

            return (
                <div
                    key={index}
                    className={className}
                    onClick={this.props.handleClick.bind(this,tab)}
                >
                    <div className={styles.caption}>{POSTBATTLE_TABS_CAPTIONS[tab]}</div>
                    <div className={styles.overlay} />
                </div>
            )
        })

        return (
            <div className={styles.base}>
                {tabs}
            </div>
        )
    }
}

export default Tabs


// WEBPACK FOOTER //
// ./containers/PostbattleScreen/components/Tabs/Tabs.jsx